export default "__VITE_ASSET__DdEgW0gr__"